export const INCIDENT_DRAWER_WIDTH = 625

export const SOP_DRAWER_WIDTH = 810
export const SOP_DRAWER_WIDTH_REBRAND = 620
export const SOP_DRAWER_BREAKPOINT = INCIDENT_DRAWER_WIDTH + SOP_DRAWER_WIDTH
export const SOP_DRAWER_BREAKPOINT_REBRAND =
  INCIDENT_DRAWER_WIDTH + SOP_DRAWER_WIDTH_REBRAND

export const MAP_PANEL_DRAWER_WIDTH = 810
export const MAP_PANEL_DRAWER_BREAKPOINT =
  INCIDENT_DRAWER_WIDTH + MAP_PANEL_DRAWER_WIDTH
